import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Tag } from 'antd';

const STATUS_LABELS = {
    pending: 'Na cekanju',
    valid: 'Validna',
    invalid: 'Nevazeca',
};

const STATUS_COLORS = {
    pending: 'gold',
    valid: 'green',
    invalid: 'red',
};

const TYPE_LABELS = {
    automatic: 'Automatska',
    manual: 'Rucna',
};

export const usePromotionEntryColumns = () => {
    const navigate = useNavigate();

    const columns = [
        {
            title: 'PFR',
            dataIndex: 'pfr',
            key: 'pfr',
        },
        {
            title: 'Tip',
            dataIndex: 'type',
            key: 'type',
            render: (type) => TYPE_LABELS[type] || type,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag color={STATUS_COLORS[status]}>{STATUS_LABELS[status] || status}</Tag>
            ),
        },
        {
            title: 'Email',
            key: 'email',
            render: (_, record) => record.user?.email || '-',
        },
        {
            title: 'Telefon',
            key: 'phone',
            render: (_, record) => record.user?.phone || '-',
        },
        {
            title: 'Datum prijave',
            dataIndex: 'submittedAt',
            key: 'submittedAt',
            render: (text) => (text ? dayjs(text).format('D MMM YYYY HH:mm') : '-'),
        },
        {
            title: 'Poreski link',
            key: 'taxLink',
            render: (_, record) =>
                record.type === 'automatic' && record.taxLink ? (
                    <a
                        href={record.taxLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        Otvori
                    </a>
                ) : (
                    '-'
                ),
        },
    ];

    const handleRowClick = (record) => {
        navigate(`/promotion/entries/${record.id}`);
    };

    return { columns, handleRowClick };
};

export { STATUS_LABELS, STATUS_COLORS, TYPE_LABELS };
